"use client";

import { forwardRef } from "react";
import { cn } from "../../lib/utils";
import {
  FILTER_ACTION_BADGE_CLASSES,
  FILTER_ACTION_BUTTON_CLASSES,
} from "./filter-action-button.constants";
import type { FilterActionButtonProps } from "./filter-action-button.types";

export const FilterActionButton = forwardRef<
  HTMLButtonElement,
  FilterActionButtonProps
>(
  (
    {
      presentation = "desktop",
      appliedCount = 0,
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <button
      ref={ref}
      type="button"
      aria-label="Filters"
      {...props}
      className={cn(
        FILTER_ACTION_BUTTON_CLASSES[presentation],
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0D41E1] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        presentation === "desktop" &&
          appliedCount > 0 &&
          "bg-[#FDF2F8] text-[#ED5AA9]",
        className,
      )}
    >
      {children}
      {appliedCount > 0 ? (
        <span
          aria-hidden="true"
          className={cn(
            "absolute flex h-[18px] w-[18px] items-center justify-center rounded-full text-[10px] font-bold text-white",
            FILTER_ACTION_BADGE_CLASSES[presentation],
          )}
        >
          {appliedCount}
        </span>
      ) : null}
    </button>
  ),
);

FilterActionButton.displayName = "FilterActionButton";
